import { CurrencySignIcon } from './CurrencySignIcon';

/**
 * author: Michael Richins
 * id 17CFE8D4-18D7-4414-B8EE-244D5A8FF791
 * name currency-sign
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-sign.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyScarabIcon = CurrencySignIcon;
export default CurrencyScarabIcon